module.exports = __webpack_public_path__ + "media/images/flags/AI-b179717a5e7631ada6d0a9feb9cd4ca0.svg";